import { Component, OnInit, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatDialog } from '@angular/material';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Router } from '@angular/router';
import { EditRrmsProbedbAllowedGtComponent } from '../Table/edit-rrms-probedb-allowed-gt/edit-rrms-probedb-allowed-gt.component';
import { AddProbAllowedGtComponent } from '../add-prob-allowed-gt/add-prob-allowed-gt.component';
import { DeleteProbAllowedGtComponent } from '../delete-prob-allowed-gt/delete-prob-allowed-gt.component';

@Component({
  selector: 'app-view-prob-allowed-gt',
  templateUrl: './view-prob-allowed-gt.component.html',
  styleUrls: ['./view-prob-allowed-gt.component.scss']
})
export class ViewProbAllowedGtComponent implements OnInit {
  getProbAllowed:any;
  itemData:any;
  cameFrom:any;
  Gt:any

  constructor(public dialogRef: MatDialogRef<ViewProbAllowedGtComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private dialog: MatDialog,
    private endpointsService:EndpointsService,private backendApiService : BackendApiService,
    private spinnerservice:Ng4LoadingSpinnerService, private router: Router) { }

  ngOnInit(): void {
    this.spinnerservice.show()
    this.itemData = this.data.rowData;
    this.cameFrom = this.data.cameFrom;
    this.Gt= this.itemData.gt
    console.log("camefrom",this.cameFrom);
    console.log("gttt",this.Gt);
    console.log("itemdataaaa",this.itemData);
    console.log("type",this.itemData.type);
    let apiUrl = this.endpointsService.URL_GET_RRMS_PROBRDB_ALLOWED_GT + '&gt='+ this.itemData.gt + '&type='+ this.itemData.type  ;
   
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.getProbAllowed = response;
      console.log("respone333",response)
    });
  }
  onClose(){
    this.dialogRef.close()
  }
  editProbDbAllowedGt(row:any){
    const dialogRef = this.dialog.open(EditRrmsProbedbAllowedGtComponent,{
      width:'1500px',
      data:{rowData:row,type:this.itemData.type},
      panelClass: 'custom-modalbox',
      disableClose: true
    });
  }
  addData(){
    const dialogRef = this.dialog.open(AddProbAllowedGtComponent, {
      width:'1200px',
      data:{gt:this.Gt,came:this.data.cameFrom,type:this.itemData.type},
       panelClass: 'custom-modalbox',
       disableClose: true
    })
    dialogRef.afterClosed().subscribe(result => {
      console.log(result,'1111')
      this.dialogRef.close('true')
      
    });
  }
  deleteProbAllowedGt(row:any){
    
    const dialogRef = this.dialog.open(DeleteProbAllowedGtComponent, {
      width:'500px',
     data:{rowData:row,type:this.itemData.type},
      panelClass: 'custom-modalbox',
      disableClose: true
      
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result,'1111')
      this.dialogRef.close('true')
      
    });
  }
  onReset() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
    // this.spinnerService.show();
  }

}
